import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AudienceModeProvider } from "./audience/AudienceModeProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { I18nProvider } from "./i18n/I18nProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Missing root element "#root"');
}

createRoot(rootEl).render(
  <StrictMode>
    <I18nProvider>
      <ThemeProvider>
        <AudienceModeProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </AudienceModeProvider>
      </ThemeProvider>
    </I18nProvider>
  </StrictMode>,
);
